import { Component, OnInit, Input } from '@angular/core';
import { ShelfPouchDb } from '../../shelf.pouchdb.service';
import { MycontentComponent } from '../../mycontent/mycontent.component';
import { bookCategories, bookCategoeyEnums } from '../../../shared/models/shelfEnums';
import { Constants } from '../../../shared/models/constants';
import * as _ from 'lodash';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConformationDialogComponent } from '../ConformationDialog/ConformationDialog.component'
import { IS_ElectronService } from '../../../shared/IS_Electron.service';
@Component({
  selector: 'app-bookdetails',
  templateUrl: './bookdetails.component.html',
  styleUrls: ['./bookdetails.component.css']
})
export class BookdetailsComponent implements OnInit {
  @Input() data: any;
  bookDetails;
  selectedTab = undefined;
  listOfElememts;
  foldersToMove;
  infoElements = [];
  bookCategoeyEnums;
  bookCategoryTypes;
  myComponent;
  templates;
  displayShelfChildsFor;
  shelfName;
  compId = false;
  shelfDataSubscription;
  constructor(public dialog: MatDialog,private pouchservice: ShelfPouchDb,private ElectronService:IS_ElectronService) { }

  bookFooterIcon = [{name:"Export",icon:'icon-Book-Export'}, {name:'Move',icon:"icon-Move-to-Folder"}, {name:"Upload",icon:"icon-Cloud-Upload"}, {name:"Delete",icon:"icon-Delete"}];
  ngOnInit() {
    var self = this;
    this.bookDetails = this.data.popupProps.curComp.selBookDetals;
    // this.pouchservice.getShelfData(this, 0);
    // this.pouchservice.alternateGetShelfData(this, 0);
    this.myComponent = MycontentComponent;
    this.bookCategoeyEnums = bookCategoeyEnums;
    this.bookCategoryTypes = bookCategories;
    if(!this.ElectronService.IS_ELECTRON){
      this.templates = Constants.getTemplates();
    }
    else{
      this.templates = Constants.getElectronTemplates();
    }  
  
    this.shelfName = this.data.popupProps.curComp.bookInfoShelfId;
    let id = Constants.USER+".04.Favourites"
    if(this.shelfName == id){
      this.compId = true;
    }


    this.shelfDataSubscription = this.pouchservice.interaction.subscribe(data => {
      self.updateListOfShlefs(data);
  })
   
  }


  ngOnDestroy(){

    if(this.shelfDataSubscription){
      this.shelfDataSubscription.unsubscribe();
    }
    
    }

  switchTabs(ind, ev) {
    ev.stopPropagation();
    this.selectedTab = ind;

    if (ind == 3) {

      this.data.popupProps.showPopup = false;
      var self = this;
          let dialogRef = this.dialog.open(ConformationDialogComponent, {
            width: '315px',
            disableClose: false
          });      
          dialogRef.afterClosed().subscribe(result => {
              if(result){ 
                document.getElementsByClassName('showApploader')[0].classList.add('hideApploader');
                if(self.ElectronService.IS_ELECTRON){
                  var deleteBookPath = self.ElectronService.USER_PATH+'/'+self.bookDetails.bId;
                  self.ElectronService.deleteFolder(deleteBookPath);
                }
                self.pouchservice.deleteBookFromShelf(self.bookDetails, self.shelfName);
              }
          })

    }
    
    if (ind == 0) {

      this.data.popupProps.curComp.manageExportPopup(this.bookDetails);
      this.data.popupProps.showPopup = false;

    }
  }

  updateListOfShlefs(data) {
    this.infoElements = _.filter(data, function (filter) { return filter.parentId == undefined || filter.parentId == "" })
  }

  moveBookTo(ev, obj, ind) {
    var shelf = this.pouchservice.getShelfById(this.shelfName);

    this.data.popupProps.showPopup = false;
    ev.dragData = {
      book: this.bookDetails,
      draggingFrom: shelf.title,
      draggingFromId:shelf._id
    };

    parent.window.document['mycompthis'].onItemDrop(ev, obj, ind, true);
  }

  makeChildrenVisibleFlase(foldersToMove) {
    for (var i = 0; i < foldersToMove.length; i++) {
      foldersToMove[i].isChildrenShow = false;
      if (foldersToMove[i].subFolder && foldersToMove[i].subFolder.length) {
        this.makeChildrenVisibleFlase(foldersToMove[i].subFolder);
      }
    }
  }

  getShelfData() {

  }

  showChildrensList(ev, obj) {
    var self = this;
    ev.stopPropagation();
    if (obj.isChildrenShow) {
      obj.isChildrenShow = false;
    } else {
      this.displayShelfChildsFor = obj;
      this.pouchservice.getShelfChildren(obj).then(function(res){
        self.updateShelfChildren(res)
      })
    }

  }

  updateShelfChildren(childs) {
    this.displayShelfChildsFor.childrenArr = childs;
    this.displayShelfChildsFor.isChildrenShow = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shelf/popups/bookdetails/bookdetails.component.ts